"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactSupportScreenBase = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var WorkflowCard_1 = require("../../components/WorkflowCard");
var Box_1 = __importDefault(require("@mui/material/Box"));
var utilityClasses_1 = require("./utilityClasses");
var base_1 = require("@mui/base");
/**
 * Component renders a screen with contact information for support with the application.
 * Contact information is pulled from the context passed into the workflow.
 *
 * @param icon the icon to display in the header
 * @param emailSupportTitle text to display as the contact support title
 * @param emailSupportContent content to display as the contact support content
 * @param phoneSupportTitle text to display as the phone support title
 * @param phoneSupportContent content to display as the phone support content
 * @param contactEmail to display the contact email
 * @param contactPhone to display contact phone number
 * @param dismissButtonLabel to display label for the button
 * @param onDismiss function to call when user clicks button
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 *
 * @category Component
 */
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        title: ['title'],
        icon: ['icon'],
        emailSupportTitle: ['emailSupportTitle'],
        emailSupportContent: ['emailSupportContent'],
        phoneSupportTitle: ['phoneSupportTitle'],
        phoneSupportContent: ['phoneSupportContent'],
        contactEmail: ['contactEmail'],
        contactPhone: ['contactPhone'],
        dismissButtonLabel: ['dismissButtonLabel'],
    };
    return (0, base_1.unstable_composeClasses)(slots, utilityClasses_1.getContactScreenUtilityClass, classes);
};
var ContactSupportScreenBase = function (props) {
    var icon = props.icon, emailSupportTitle = props.emailSupportTitle, emailSupportContent = props.emailSupportContent, phoneSupportTitle = props.phoneSupportTitle, phoneSupportContent = props.phoneSupportContent, contactEmail = props.contactEmail, contactPhone = props.contactPhone, dismissButtonLabel = props.dismissButtonLabel, onDismiss = props.onDismiss;
    var defaultClasses = useUtilityClasses(props);
    var cardBaseProps = props.WorkflowCardBaseProps || {};
    var headerProps = props.WorkflowCardHeaderProps || {};
    var instructionsProps = props.WorkflowCardInstructionProps || {};
    var actionsProps = props.WorkflowCardActionsProps || {};
    return (react_1.default.createElement(WorkflowCard_1.WorkflowCard, __assign({}, cardBaseProps, { className: defaultClasses.root, "data-testid": defaultClasses.root }),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardHeader, __assign({}, headerProps, { className: defaultClasses.title, "data-testid": defaultClasses.title })),
        Object.keys(instructionsProps).length !== 0 && react_1.default.createElement(WorkflowCard_1.WorkflowCardInstructions, __assign({}, instructionsProps)),
        icon && (react_1.default.createElement(Box_1.default, { sx: { m: 3, mb: 5, textAlign: 'center' }, className: defaultClasses.icon }, icon)),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardBody, null,
            react_1.default.createElement(material_1.Typography, { className: defaultClasses.emailSupportTitle, "data-testid": defaultClasses.emailSupportTitle, variant: "body1", sx: { mb: 1 } },
                ' ',
                emailSupportTitle),
            react_1.default.createElement(react_1.default.Fragment, null, emailSupportContent === null || emailSupportContent === void 0 ? void 0 : emailSupportContent(contactEmail !== null && contactEmail !== void 0 ? contactEmail : '')),
            react_1.default.createElement(material_1.Typography, { className: defaultClasses.phoneSupportTitle, "data-testid": defaultClasses.phoneSupportTitle, variant: "body1", sx: { mt: 4, mb: 1 } },
                ' ',
                phoneSupportTitle),
            react_1.default.createElement(react_1.default.Fragment, null, phoneSupportContent === null || phoneSupportContent === void 0 ? void 0 : phoneSupportContent(contactPhone !== null && contactPhone !== void 0 ? contactPhone : ''))),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardActions, __assign({}, actionsProps, { nextLabel: dismissButtonLabel || actionsProps.nextLabel, className: defaultClasses.dismissButtonLabel, onNext: function () {
                if (onDismiss)
                    onDismiss();
                if (actionsProps.onNext)
                    actionsProps.onNext();
            } }))));
};
exports.ContactSupportScreenBase = ContactSupportScreenBase;
